module.exports = __webpack_public_path__ + "static/media/poster.d2e67815.jpg";